import React, { Component } from "react";
import { Button, IconButton, Icon, withStyles, Card, DialogContent, Dialog, DialogActions, DialogTitle, Typography, MenuItem, InputLabel, Radio, FormControlLabel, RadioGroup, Badge, Drawer } from "@material-ui/core";
import Grid, { default as MaterialGrid } from '@material-ui/core/Grid';

import Select from '@material-ui/core/Select';
import FilterListIcon from '@material-ui/icons/FilterList';
// import Chart from "react-google-charts";

import { DateRangePicker, DateRange } from "materialui-daterange-picker";
import moment from 'moment';//moment
import 'moment-timezone';//timezone

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'


import { Link } from "react-router-dom";
import * as actions from '../../../store/actions/index';
import { connect } from "react-redux";

class PipelineSummaryDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportTitile: "Pipeline Summary ",
            reportSubTitle: " Summary of your pipeline by stage, based on Opportunity close date.",
            totalvalue: "$0 K",
            totalopp: "3",
            selectedPipline: "1",
            selectedFilter: "1",
            value_type: "1",
            drawerOpen: false,
            dateopen: false,
            dateformat: 'MM/DD/YYYY',
            // selectedDate: null
            selectedDate: { from: moment().startOf("month").format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') },
            selectedDatelabel: "",

            definedRanges: [
                {
                    label: "Today",
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },

                {
                    label: "Yesterday",
                    startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                    endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
                },

                {
                    label: "This Week",
                    startDate: moment().day(1),
                    endDate: moment().day(7)
                },

                {
                    label: "This Month",
                    startDate: moment().startOf("month").format('YYYY-MM-DD'),
                    endDate: moment().endOf("month")
                },

                {
                    label: "This Quarter",
                    startDate: moment().startOf('quarter'),
                    endDate: moment().endOf('quarter')
                },

                {
                    label: "This Year",
                    startDate: moment().startOf('year'),
                    endDate: moment().endOf('year')
                },

                {
                    label: "Last 7 days",
                    startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },

                {
                    label: "Last 30 days",
                    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },
            ],
            fromdate: moment().startOf('month').subtract(2, 'months').format('YYYY-MM-DD'),
            todate: moment().endOf('month').format('YYYY-MM-DD'),
            pipelineList: [],
            pipelinesummarydata: [],
            fieldDisplay: [],
            dropdownhide: [],
            systemTagsList: [],
            masterActivityTypesList: [],
            usersListArray: [],
        }
    }
    componentDidMount() {
        // this.setState({ selectedDate: moment().format(this.state.dateformat) })

        localStorage.removeItem('selected_report_pipeline_summary_filter_id');

        this.props.getPipelines(this.props.apolloClient.client);
        let piplineparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: moment().startOf('month').subtract(2, 'months').format('YYYY-MM-DD'),
            todate: moment().endOf('month').format('YYYY-MM-DD'),
            memberid: 0
        };

        this.get(piplineparams);

        let val = { typeId: 4 }
        this.props.customFieldList(this.props.apolloClient.client, val);
        this.props.getTagsList(this.props.apolloClient.client);
        this.props.getUserList(this.props.apolloClient.client);
        this.props.getActivityTypes(this.props.apolloClient.client);

        this.setState({ selectedDate: { from: moment().startOf("month").format(this.state.dateformat), to: moment().endOf('month').format(this.state.dateformat) } })

    }
    componentWillReceiveProps(props) {
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;
            this.setState({ dateformat: usersetting.dateformat, timeZone: usersetting.timezone })
        }

        if (props.settingReducer.masterActivityTypesList && props.settingReducer.masterActivityTypesList.is_loaded == true && props.settingReducer.masterActivityTypesList.data) {
            props.settingReducer.masterActivityTypesList.is_loaded = false
            var dataList = props.settingReducer.masterActivityTypesList.data;
            var count = dataList.filter(function (element) {
                if (element.is_disable == true) {
                    return element
                }
            });
            this.setState({
                masterActivityTypesList: dataList,
            });
        }

        if (props.settingReducer.pipelineListArray && props.settingReducer.pipelineListArray.data) {
            this.setState({ pipelineList: props.settingReducer.pipelineListArray.data })
        }

        if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
            const usersListArray = props.settingReducer.usersListArray.data;
            this.setState({ usersListArray: usersListArray })
        }

        if (props.reportReducer.reportPipelineSummary && props.reportReducer.reportPipelineSummary.data) {
            let pipelinesummarydata = props.reportReducer.reportPipelineSummary.data.data

            let totalvalue = (pipelinesummarydata.graphval.length > 0) ? pipelinesummarydata.graphval.reduce(this.add) / 1000 : 0;
            this.setState({ pipelinesummarydata, totalvalue: "$" + totalvalue + " k" })
        }
    }
    getpiplineSummary = (piplineparams) => {
        let data = piplineparams;
        data.memberid = 0
        this.props.piplineSummary(this.props.apolloClient.client, data);
    }

    add = (a, b) => {
        return a + b;
    }

    handlePiplineChange = (event) => {

        let piplineparams = {
            filterdata: [],
            piplineid: parseFloat(event.target.value),
            type: parseFloat(this.state.value_type),
            fromdate: this.state.fromdate,
            todate: this.state.todate,
            memberid: 0
        };
        this.getpiplineSummary(piplineparams);

        this.setState({ [event.target.name]: event.target.value })
    }

    // handleChange = (event) => {
    //     this.setState({ [event.target.name]: event.target.value })
    // }

    // handleOpenDrawer = () => {
    //     this.setState({ drawerOpen: true, })
    // }

    // handleCloseDrawer = () => {
    //     this.setState({ drawerOpen: false, })
    // }

    toggle = () => {
        this.setState({ dateopen: !this.state.dateopen });
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    }

    render() {
        let { pipelinesummarydata, pipelineList, reportTitile, reportSubTitle, dateopen, selectedFilter, totalvalue, drawerOpen, totalopp, selectedPipline, value_type } = this.state;

        let stages = [];
        let data = [];

        var localStorageFilter = localStorage.getItem('selected_report_pipeline_summary_filter_id');

        if (pipelinesummarydata && pipelinesummarydata.stage && pipelinesummarydata.graphval) {
            stages = pipelinesummarydata && pipelinesummarydata.stage;
            data = pipelinesummarydata && pipelinesummarydata.graphval;
        } else {
            let selectedStages = [];
            let pipelinekey = this.findWithAttr(pipelineList, 'id', selectedPipline);

            if (pipelinekey != -1) {
                selectedStages = pipelineList[pipelinekey].stage;
                selectedStages.map((stage, key) => {
                    stages.push(stage.name);
                    data.push(0);
                });
            }
        }


        const options = {
            chart: { type: 'column' },
            title: "",
            subtitle: "",
            xAxis: {
                title: {
                    text: null
                },
                categories: stages,
                crosshair: true
            },
            yAxis: {
                title: { text: null },
                min: 0,
                labels: {
                    formatter: function () {
                        return '$' + this.value;
                    }
                }
            },
            tooltip: {
                headerFormat: '<b><span style="font-size:14px">{point.key}</span></b><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                color: "#2196f3",
                name: 'Total Value',
                data: data
            }]
        }
        // const options = {
        //     chart: { height: 300, type: 'column' },
        //     title: "",
        //     subtitle: "",
        //     xAxis: {
        //         title: {
        //             text: null
        //         },
        //         categories: [
        //             'Qualified',
        //             'Follow-up',
        //             'Presentation',
        //             'Contract Sent',
        //             'Negotiation',
        //         ],
        //         crosshair: true
        //     },
        //     yAxis: {
        //         title: { text: null },
        //         min: 0,
        //         labels: {
        //             formatter: function () {
        //                 return '$' + this.value;
        //             }
        //         }
        //     },
        //     tooltip: {
        //         headerFormat: '<b><span style="font-size:14px">{point.key}</span></b><table>',
        //         pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        //             '<td style="padding:0"><b>{point.y}</b></td></tr>',
        //         footerFormat: '</table>',
        //         shared: true,
        //         useHTML: true
        //     },
        //     legend: {
        //         enabled: false
        //     },
        //     plotOptions: {
        //         column: {
        //             pointPadding: 0.2,
        //             borderWidth: 0
        //         }
        //     },
        //     series: [{
        //         color: "#2196f3",
        //         name: 'Total Value',
        //         data: [235, 80, 885, 105, 70]

        //     }]
        // }

        return (
            <Card elevation={3} className="dashboard_card mb-10">
                <div className="report_card">
                    <div className="report_header">
                        <Grid container justify="space-between">
                            <h3 className="text-primary">{reportTitile}</h3>
                            <Link className="viewmore text_link" to="/reports/report-default/">View Full Report</Link>
                        </Grid>
                        <p className="font-size-14 m-0 mb-10 p-0">{this.state.selectedDatelabel == "" ? this.state.selectedDate.from + " to " + this.state.selectedDate.to : this.state.selectedDatelabel}</p>
                        <Grid container direction="row" justify="flex-start" >
                            <div className="number_label">
                                Total Pipeline Value<br /><div className="font-size-30">{totalvalue}</div>
                            </div>
                            <div className="number_label">
                                Opportunities<br /><div className="font-size-30">{pipelinesummarydata.totalopportunities}</div>
                            </div>
                            <Select
                                className="w-200 m-10 mt-30"
                                labelId="Pipeline-select-label"
                                name="selectedPipline"
                                id="Pipeline"
                                value={selectedPipline}
                                onChange={this.handlePiplineChange}
                            >
                                {pipelineList && pipelineList.map((pipeline, i) => (
                                    <MenuItem key={i} value={pipeline.id}>{pipeline.name}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </div>
                    <div className="report_content">
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                        />
                    </div>
                </div>
            </Card >
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
    notification: state.notification,
    reportReducer: state.reportReducer,
});
const mapDispatchToProps = dispatch => {
    return {
        getPipelines: (client) => dispatch(actions.getPipelines(client)),
        getTagsList: (client) => dispatch(actions.getTagsList(client)),
        getUserList: (client) => dispatch(actions.getUserList(client)),
        getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
        customFieldList: (client, value) => dispatch(actions.customFieldList(client, value)),

        piplineSummary: (client, value) => dispatch(actions.piplineSummary(client, value)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PipelineSummaryDashboard);